import React, { useState } from 'react';
import { TrackerWatchDoc } from '../../types';
import TrackerModal from './TrackerModal';

interface Props {
  watch: TrackerWatchDoc;
  defaultEmail?: string;
  onSave: (next: { email: string; emailAlerts: boolean }) => void;
  onClose: () => void;
}

const WORK_EMAIL_RE = /^[^@\s]+@rubyoncology\.com$/i;

/** tracker.js's openAlerts(): configures the weekday watchlist-digest email, from the Favorites bar's
 * "Email alerts" button. Defaults to the logged-in user's own address until they save a different one. */
const EmailAlertsModal: React.FC<Props> = ({ watch, defaultEmail, onSave, onClose }) => {
  const [email, setEmail] = useState(watch.email || defaultEmail || '');
  const [on, setOn] = useState(!!watch.emailAlerts);
  const [note, setNote] = useState('');

  const save = () => {
    const trimmed = email.trim();
    if (on && !WORK_EMAIL_RE.test(trimmed)) { setNote('Use your @rubyoncology.com address.'); return; }
    onSave({ email: trimmed, emailAlerts: on });
    onClose();
  };

  return (
    <TrackerModal title="Email alerts" onClose={onClose} footer={<button type="button" className="ib primary" onClick={save}>Save</button>}>
      <p className="policy">
        On weekday mornings, after the automatic check, you get one email listing what changed on anything you watch
        and what falls due in the next 14 days. Nothing is sent on days with nothing to report. Digests go only to
        @rubyoncology.com addresses.
      </p>
      <div className="form">
        <label className="full">
          Your work email
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@rubyoncology.com" />
        </label>
        <label className="inline full">
          <input type="checkbox" checked={on} onChange={(e) => setOn(e.target.checked)} /> Email me the watchlist digest
        </label>
        {note && <p className="note">{note}</p>}
      </div>
    </TrackerModal>
  );
};

export default EmailAlertsModal;
